"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import type { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { useAuth } from "@/components/auth/Auth";
import PencilIcon, { PencilIconSize } from "@/components/utils/icons/PencilIcon";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function ProfileProxyCredit(t0) {
  const $ = _c(11);
  const {
    profileProxy,
    profileProxyAction,
    onCreditEdit
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const isOwner = connectedProfile?.id === profileProxy.created_by.id;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-font-normal tw-text-iron-500">Credit:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = profileProxyAction.credit_amount ?? 0;
  let t3;
  if ($[1] !== t2) {
    t3 = formatNumberWithCommas(t2);
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <p className="tw-mb-0 tw-flex tw-items-center tw-gap-x-1.5 tw-text-md tw-font-normal tw-text-iron-500">{t1}<span className="tw-font-medium tw-text-iron-300">{t3}</span></p>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOwner || $[6] !== onCreditEdit) {
    t5 = isOwner && <button type="button" aria-label="Edit credit" className="tw-group tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-400" onClick={onCreditEdit}><PencilIcon size={PencilIconSize.SMALL} /></button>;
    $[5] = isOwner;
    $[6] = onCreditEdit;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="tw-flex tw-items-center lg:tw-justify-center">{t4}{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}